import { queryStringToObject } from '@fiverr-private/futile/lib/url';
import { mixpanel } from '@fiverr-private/obs';
import _ from 'lodash';

const sellerLevels = [
    'Entry level',
    'Level 1 Seller',
    'Level 2 Seller',
    'Top Rated Seller'
];

export const Events = {
    GeneralEvents: {
        GENERIC_VIEWED_PAGE: 'Viewed page',
        INTERACTED: 'Seller Page - Reviews Interaction',
        SELLER_PAGE_VIEW: 'Seller Page - View',
        TAG_CLICKED: 'tag clicked',
        GET_A_QUOTE_CLICKED: 'Seller Page - clicked Get a Quote ',
        CLICKED_CONTACT_ME: 'Seller Page - clicked Contact Me',
        MP_VIEWED_LOYALTY_SELLER_BANNER: 'Viewed Loyalty Seller Banner',
        MP_VIEWED_LOYALTY_BANNER_TOOLTIP: 'Viewed Loyalty Banner Tooltip'
    },
    Coupon: {
        DISMISS_BOMBA: 'User Profile Page - Dismiss Coupon bomba',
        SEEN_BOMBA: 'User Profile Page - Seen Coupon bomba',
        OPEN_ARTICLE: 'User Profile Page - Clicked Coupon article link',
        SEEN_MODAL: 'User Profile Page - Seen Coupon modal'
    },
    NotableClients: {
        VIEWED_NOTABLE_CLIENTS: 'seller page - notable clients viewed'
    }
};

export const Pages = {
    USER_PAGE: 'User profile',
    GIG_PAGE: 'Gig page'
};

export function triggerMixPanelEvent(eventName, userData = {}, gigs, extraData = {}, source = 'Main menu') {
    const {
        seller_card,
        buying_reviews,
        portfolio,
        user
    } = userData;

    const urlParams = queryStringToObject(window.location.search.replace('?', ''));
    const sourceComponent = urlParams.source
        ? { 'Source component': urlParams.source }
        : {};
    const sellerLevel = _.get(sellerLevels, 'seller_card.user.achievement', sellerLevels[0]);
    const propsData = _.isEmpty(userData) ? {} : {
        'Number of gigs': gigs.length,
        'Number of pro gigs': gigs.filter((gig) => gig.is_pro).length,
        'Number of buying reviews': buying_reviews.total_count,
        'Pro Seller': seller_card.user.is_pro,
        'Seller Level': sellerLevel,
        'Portfolio exist': !!portfolio?.portfolio_projects?.length,
        'Navigation source': source,
        'Seller Name': user.username,
        'Seller Id': user.id
    };

    sendMixPanelEvents(eventName, {
        'Page name': Pages.USER_PAGE,
        ...propsData,
        ...sourceComponent,
        ...extraData
    });
}

export const sendMixPanelEvents = (eventName, additionalData = {}) => {
    if (eventName === Events.GeneralEvents.VIEWED_PAGE) {
        mixpanel.trackPageView({
            'Page Name': 'Seller Page',
            ...additionalData
        });
    } else {
        mixpanel.track(eventName, additionalData);
    }
};
